import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import { cleanObject } from 'marketplace-ui-common/utils/formatters';
const moduleContentItemDefaults = {
  categories: [],
  contentTypes: []
};
export default class ModuleContentItem extends createImmutableObjectClass(moduleContentItemDefaults, {
  fromJSON: (_ref) => {
    let rest = Object.assign({}, _ref);
    return cleanObject(Object.assign({}, rest));
  },
  toJSON: (_ref2) => {
    let rest = Object.assign({}, _ref2);
    return Object.assign({}, rest);
  }
}) {}